import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import StatsSection from "./components/StatsSection";
import CategoryGrid from "./components/CategoryGrid";
import WhyVigorbuy from "./components/WhyVigorbuy";
import BlogPreview from "./components/BlogPreview";
import FaqSection from "./components/FaqSection";
import CtaBanner from "./components/CtaBanner";

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://vigorbuy.blog';

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Vigorbuy Spreadsheet 2026: Ultimate Shopping Guide & Best Product Finds",
  "description": "Discover the latest Vigorbuy Spreadsheet with 15,000+ verified product finds, QC guides, and shopping tips. Updated daily with trusted recommendations.",
  "url": `${SITE_URL}/`,
  "dateModified": "2026-06-28",
  "publisher": {
    "@type": "Organization",
    "name": "Vigorbuy.blog",
    "url": SITE_URL
  }
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}></script>
      <Navbar />
      <Hero />
      <StatsSection />
      <CategoryGrid />
      <WhyVigorbuy />
      <BlogPreview />
      <FaqSection />
      <CtaBanner />
      <Footer />
    </main>
  );
}